/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
export const awsAuth = {
    "aws_project_region": "us-east-2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ycqvCvaOo",
    "aws_user_pools_web_client_id": "5d8s3emjop0s3m8ttih1laffuc",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};
export const awsAuthHosted = {
    "aws_project_region": "us-east-2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ycqvCvaOo",
    "aws_user_pools_web_client_id": "5d8s3emjop0s3m8ttih1laffuc",
    "oauth": {
        "domain": "gytpol-saas-deltadental.auth.us-east-2.amazoncognito.com",
        "scope": ["email", "openid","profile"],     // "aws.cognito.signin.user.admin"
        "redirectSignIn": "https://deltadental.us.cloud.gytpol.com",
        "redirectSignOut": "https://deltadental.us.cloud.gytpol.com",
        "region": "us-east-2",
        "responseType": "code"
    }
};
